/** @format */

export const dealDataMethod = (obj) => {
	const object = JSON.parse(JSON.stringify(obj));
	object &&
		object.fieldList.map((item) => {
			item.fieldGroup.map((item1) => {
				item1.fieldCode = `${item.resCode}.${item1.fieldCode}`;
			});
		});
	return object;
};
